import reduxConnector from 'root/src/shared/util/reduxConnector'
import miscModuleTypeSelector from 'root/src/client/logic/misc/miscModule/selectors/miscModuleTypeSelector'

export default reduxConnector(
	[
		['miscModuleType', miscModuleTypeSelector],
	],
	[],
)
